import { render, staticRenderFns } from "./human.vue?vue&type=template&id=0ba6443a&scoped=true"
import script from "./human.vue?vue&type=script&lang=js"
export * from "./human.vue?vue&type=script&lang=js"
import style0 from "./human.vue?vue&type=style&index=0&id=0ba6443a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba6443a",
  null
  
)

export default component.exports